'use strict';

var log10 = require('./log').log10; // Map a value from [min, max] to [0, 1].
// Defaults to linear interpolation, but can optionally map logarithmically.
// If the input has no expected variance, all values return 0.5.
//
// @param  {Number}  value
// @param  {Object}  stats
// @param  {Number}  stats.min  The smallest expected value
// @param  {Number}  stats.max  The largest expected value
// @param  {Boolean} log        Apply logarithmic scaling
// @return {Number}             value mapped between [0, 1]


function mapValue(value, stats, log) {
  var mappedValue = void 0;
  var range = stats.max - stats.min;

  if (range === 0) {
    return 0.5;
  }

  value = Number.parseFloat(value);

  if (log) {
    mappedValue = (log10(value) - log10(stats.min)) / (log10(stats.max) - log10(stats.min));
  } else {
    mappedValue = (value - stats.min) / range;
  }

  if (Number.isNaN(mappedValue)) {
    return undefined;
  }

  return mappedValue;
} // Map a value from [0, 1] to [min, max]
// @param {Boolean} log - Apply logarithmic scaling


function unmapValue(v, stats, log) {
  var n = void 0;

  if (log) {
    // Re-arrange
    //   v = (log(n) - log(min)) / (log(max) - log(min))
    // to solve for n
    //   n = min^(1-v) * max^(v)
    n = Math.pow(stats.min, 1 - v) * Math.pow(stats.max, v);
  } else {
    // Re-arrange
    //   v = (n - min) / (max - min)
    // to solve for n
    //   n = v(max - min) + min
    n = v * (stats.max - stats.min) + stats.min;
  }

  if (Number.isNaN(n)) {
    return undefined;
  }

  return n;
}

module.exports = {
  mapValue: mapValue,
  unmapValue: unmapValue
};